import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import Dropdown from './Dropdown'

let EditCellDropdown = ({
  disabled,
  options,
  onChange,
  value: initialValue,
  selectedValueFormat = v => v,
  optionFormat = v => v,
  emptyOptionsText = '',
  align = 'right',
  warnForMissingValues = true,
  allowCustomValue = false,
}) => {
  let [value, setValue] = useState('')
  let [customValue, setCustomValue] = useState('')

  useEffect(() => {
    // do this to optimistically update value, and then set it from initial
    setValue(initialValue)
  }, [initialValue])

  return (
    <Dropdown
      className="input-group-prepend"
      tag="span"
      align={align}
      trigger={
        <button
          disabled={disabled}
          className="btn btn-sm btn-outline-secondary dropdown-toggle w-100"
          type="button"
          style={{ lineHeight: 1 }}
        >
          {value && warnForMissingValues && !options.includes(value) && (
            <i className="mr-2 fa fa-exclamation-circle" />
          )}
          {selectedValueFormat(value)}
        </button>
      }
    >
      {closeDropdown => (
        <>
          {_.isEmpty(options) ? (
            <div className="dropdown-item small" onClick={_.noop}>
              {emptyOptionsText}
            </div>
          ) : (
            options.map(o => (
              <button
                key={o}
                className="dropdown-item small"
                onClick={e => {
                  closeDropdown(e)
                  onChange({ value: o, setDropdownValue: setValue })
                  setCustomValue('')
                }}
              >
                {optionFormat(o)}
              </button>
            ))
          )}
          {allowCustomValue && (
            <>
              <div className="dropdown-divider" />
              <div className="px-4 pb-2 mt-3">
                <form
                  className="input-group"
                  style={{ minWidth: '200px' }}
                  onSubmit={e => {
                    e.preventDefault()
                    closeDropdown(e)
                    onChange({ value: customValue, setDropdownValue: setValue })
                    setCustomValue('')
                  }}
                >
                  <input
                    className="form-control form-control-sm"
                    placeholder="Custom Value..."
                    onClick={e => e.stopPropagation()}
                    onChange={e => setCustomValue(e.target.value)}
                    value={customValue}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-sm btn-secondary"
                      disabled={!customValue}
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </>
          )}
        </>
      )}
    </Dropdown>
  )
}

export default EditCellDropdown
